import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Container, Row, Col, Card } from "react-bootstrap";
import "swiper/css";
import "swiper/css/effect-fade";
import slide1 from "../../Assets/Image/slide1.jpg";
import slide2 from "../../Assets/Image/slide2.jpg";
import slide3 from "../../Assets/Image/slide3.jpg";
import { Autoplay, EffectFade } from "swiper/modules";
import { Navigation } from "swiper/modules";
import exImg1 from "../../Assets/Image/expertise-001.jpg";
import exImg2 from "../../Assets/Image/expertise-002.jpg";
import exImg3 from "../../Assets/Image/expertise-003.jpg";
import exImg4 from "../../Assets/Image/expertise-004.jpg";
import exImg5 from "../../Assets/Image/expertise-005.jpg";
import exImg6 from "../../Assets/Image/expertise-006.jpg";
import Marquee from "react-fast-marquee";
import AOS from "aos";
import "aos/dist/aos.css";
import { Button } from "react-bootstrap";
import { title } from "process";
import { descriptors } from "chart.js/dist/core/core.defaults";

// icons
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import VpnLockIcon from "@mui/icons-material/VpnLock";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import CrisisAlertIcon from '@mui/icons-material/CrisisAlert';
export default function Index() {
  const slides = [
    {
      image: slide1,
      text: "AI-Powered Auto-Trading for Maximum Profits!",
      topText: "Nexus Tradezz Forex",
    },
    {
      image: slide2,
      text: "Unlock Financial Freedom with Nexus Tradezz",
      topText: "Nexus Tradezz Forex",
    },
    {
      image: slide3,
      text: "Trade Smarter, Profit Faster",
      topText: "Nexus Tradezz Forex Broken House ",
    },
  ];

  const cardData = [
    {
      number: "01",
      title: "Vision to plan",
      description: "Transform ideas into actionable success strategies.",
    },
    {
      number: "02",
      title: "Plan to market",
      description: "Execute strategies for maximum market impact.",
    },
    {
      number: "03",
      title: "Market to growth",
      description: "Scale faster with data-driven growth solutions.",
    },
  ];

  const expertiesData = [
    {
      id: 1,
      title: "Smart Trading",
      description: "AI-powered automation for precision trading.",
      icon: MonetizationOnIcon,
      exImg: exImg1,
    },
    {
      id: 2,
      title: "Secure Brokerage",
      description: "Trusted platform with fast & transparent execution.",
      icon: VpnLockIcon,
      exImg: exImg2,
    },
    {
      id: 3,
      title: "Market Insights",
      description: "Data-driven analysis for profitable decisions..",
      icon: TrendingUpIcon,
      exImg: exImg3,
    },
    {
      id: 4,
      title: "Growth Strategy",
      description: "Scalable solutions for long-term success.",
      icon:  MonetizationOnIcon, // Replace with an actual icon if needed
      exImg: exImg4,
    },
    {
      id: 5,
      title: "Risk Management",
      description: "Minimize losses with advanced risk strategies.",
      icon: CrisisAlertIcon, // Replace with an actual icon if needed
      exImg: exImg5,
    },
    {
      id: 6,
      title: "24/7 Support",
      description: "Expert assistance for seamless trading.",
      icon: SupportAgentIcon, // Replace with an actual icon if needed
      exImg: exImg6,
    },
  ];

  const [autoText, setAutoText] = useState("");
  const [currentSlide, setCurrentSlide] = useState(0);
  const [livePrice, setLivePrice] = useState(null);

  const [liveprices, setLivePrices] = useState([
    // { symbol: "BTC", price: 0 },
    // { symbol: "ETH", price: 0 },
    // { symbol: "BNB", price: 0 },
  ]);

  useEffect(() => {
    if (currentSlide < 0 || currentSlide >= slides.length) return;
    const text = slides[currentSlide]?.text || "";
    const words = text.split(" ");

    setAutoText("");

    let index = 0;
    let newText = "";
    const interval = setInterval(() => {
      if (index < words.length) {
        newText += (index === 0 ? "" : " ") + words[index];
        setAutoText(newText);
        index++;
      } else {
        clearInterval(interval);
        setTimeout(() => setAutoText(""), 1000);
      }
    }, 500);

    return () => clearInterval(interval);
  }, [currentSlide]);

  const calculateDelay =
    (slides[currentSlide]?.text.split(" ").length || 0) * 500 + 1500;

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: "ease-in-out",
    });
  }, []);


  const [isTawkLoaded, setIsTawkLoaded] = useState(false);

  useEffect(() => {
    if (!isTawkLoaded) {
      // Set visitor info BEFORE the script loads
      // window.Tawk_API = window.Tawk_API || {};
      // window.Tawk_API.visitor = {
      //   name: 'Nexus', // Replace with dynamic user data if available
      //   email: 'Nexus@example.com'
      // };

      const tawkScript = document.createElement("script");
      tawkScript.src = "https://embed.tawk.to/67fa294c0d9928190ebbc76c/default";
      tawkScript.async = true;
      tawkScript.charset = "UTF-8";
      tawkScript.setAttribute("crossorigin", "*");
      document.body.appendChild(tawkScript);

      setIsTawkLoaded(true);
    }
  }, [isTawkLoaded]);

  const fetchLivePrices = async () => {
    try {
      const response = await fetch(
        "https://v6.exchangerate-api.com/v6/ce7ee80e0eabba28d6aff7b4/latest/USD"
      );
      const data = await response.json();
      setLivePrices([
        { pair: "USD/EUR", rate: data.conversion_rates.EUR },
        { pair: "USD/GBP", rate: data.conversion_rates.GBP },
        { pair: "USD/JPY", rate: data.conversion_rates.JPY },
        { pair: "USD/AUD", rate: data.conversion_rates.AUD },
        { pair: "USD/CAD", rate: data.conversion_rates.CAD },
        { pair: "USD/CHF", rate: data.conversion_rates.CHF },
        { pair: "USD/NZD", rate: data.conversion_rates.NZD },
        { pair: "USD/SGD", rate: data.conversion_rates.SGD },
        { pair: "USD/HKD", rate: data.conversion_rates.HKD },
        { pair: "USD/CNY", rate: data.conversion_rates.CNY },
        { pair: "USD/INR", rate: data.conversion_rates.INR },
        { pair: "USD/KRW", rate: data.conversion_rates.KRW },
        { pair: "USD/BRL", rate: data.conversion_rates.BRL },
        { pair: "USD/ZAR", rate: data.conversion_rates.ZAR },
        { pair: "USD/MXN", rate: data.conversion_rates.MXN },
      ]);
    } catch (error) {
      console.error("Error fetching prices:", error);
    }
  };

  // fetchLivePrices();

  return (
    <div className="index-wrapper">
      <div className="slide-container">
        <Swiper
          modules={[Autoplay, EffectFade]}
          effect="fade"
          autoplay={{
            delay: calculateDelay,
            disableOnInteraction: false,
          }}
          loop={true}
          className="mySwiper"
          onSlideChange={(swiper) => setCurrentSlide(swiper.realIndex)}
        >
          {slides.map((slide, index) => (
            <SwiperSlide key={index}>
              <div
                className="slide"
                style={{ backgroundImage: `url(${slide.image})` }}
              >
                <div className="top-slide-link">
                  {/* <p> {slide.topText}</p> */}
                </div>
                <div className="slide-text" data-aos="fade-up">
                  {autoText} <br />
                </div>
                <div className="getting-star-button">
                  <button className="gs-btn"> Get Started Now </button>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <Container className="cards-container">
        <Row className="justify-content-center">
          {cardData.map((item, index) => (
            <Col
              key={index}
              md={4}
              sm={12}
              className="d-flex justify-content-center"
            >
              <Card className="custom-card">
                <div className="circle">{item.number}</div>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>

      <div className="index-about-sec">
        <Container>
          <Row>
            <Col md={6} className="content">
              <h1>Nexus Tradezz: Redefining Forex Excellence</h1>
              <ul>
                <li>
                  <span className="checkmark">✔</span>
                  AI-driven trading for smarter investments.
                </li>
                <li>
                  <span className="checkmark">✔</span>
                  Secure, fast, and profit-optimized solutions.
                </li>
              </ul>
              <div className="buttons">
                <Button variant="dark">ABOUT COMPANY</Button>
                <Button variant="outline-dark">HOW WE WORK</Button>
              </div>
            </Col>

            <Col md={6} className="robot-image"></Col>
          </Row>
        </Container>
        <div className="marquee">
          <div className="marquee-content">
            <Marquee speed={70} >
              USD1.0000 <span className="red">▼-0.0002</span> | USD/JPY 147.6500 <span className="green">▲ 0.0001</span> |
              AUD/USD 1.0000 <span className="red">▼-0.0008</span> | USD/CHF 0.8780 <span className="green">▲ 0.0004</span> |
              CAD/USD 1.0000 <span className="green">▲ 0.0002</span> | NZD/USD 1.0000 <span className="green">▲ 0.0002</span>

              USD1.0000 <span className="red">▼-0.0002</span> | USD/JPY 147.6500 <span className="green">▲ 0.0001</span> |
              AUD/USD 1.0000 <span className="red">▼-0.0008</span> | USD/CHF 0.8780 <span className="green">▲ 0.0004</span> |
              CAD/USD 1.0000 <span className="green">▲ 0.0002</span> | NZD/USD 1.0000 <span className="green">▲ 0.0002</span>

              USD1.0000 <span className="red">▼-0.0002</span> | USD/JPY 147.6500 <span className="green">▲ 0.0001</span> |
              AUD/USD 1.0000 <span className="red">▼-0.0008</span> | USD/CHF 0.8780 <span className="green">▲ 0.0004</span> |
              CAD/USD 1.0000 <span className="green">▲ 0.0002</span> | NZD/USD 1.0000 <span className="green">▲ 0.0002</span>

              USD1.0000 <span className="red">▼-0.0002</span> | USD/JPY 147.6500 <span className="green">▲ 0.0001</span> |
              AUD/USD 1.0000 <span className="red">▼-0.0008</span> | USD/CHF 0.8780 <span className="green">▲ 0.0004</span> |
              CAD/USD 1.0000 <span className="green">▲ 0.0002</span> | NZD/USD 1.0000 <span className="green">▲ 0.0002</span>

              USD1.0000 <span className="red">▼-0.0002</span> | USD/JPY 147.6500 <span className="green">▲ 0.0001</span> |
              AUD/USD 1.0000 <span className="red">▼-0.0008</span> | USD/CHF 0.8780 <span className="green">▲ 0.0004</span> |
              CAD/USD 1.0000 <span className="green">▲ 0.0002</span> | NZD/USD 1.0000 <span className="green">▲ 0.0002</span>

              USD1.0000 <span className="red">▼-0.0002</span> | USD/JPY 147.6500 <span className="green">▲ 0.0001</span> |
              AUD/USD 1.0000 <span className="red">▼-0.0008</span> | USD/CHF 0.8780 <span className="green">▲ 0.0004</span> |
              CAD/USD 1.0000 <span className="green">▲ 0.0002</span> | NZD/USD 1.0000 <span className="green">▲ 0.0002</span>
            </Marquee>
          </div>
        </div>
      </div>

      <section className="expertise-section">
        <Container>
          <div className="text-center">
            <p className="sub-heading">PROFESSIONAL SERVICES</p>
            <h2 className="main-heading">Our Expertise</h2>
          </div>
          <Swiper
            slidesPerView={2}
            spaceBetween={20}
            loop={true}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            navigation={true}
            modules={[Autoplay, Navigation]}
            breakpoints={{
              0: { slidesPerView: 1 },
              768: {
                slidesPerView:2,
              }
           
            }}
            className="expertise-slider"
          >
            {expertiesData.map((item) => (
              <SwiperSlide key={item.id}>
                <div className="expertise-card">
                  <div className="ex-card-data">
                    <span className="expertise-icon">
                      {typeof item.icon === "string" ? (
                        item.icon
                      ) : (
                        <item.icon className="icon-ex" />
                      )}
                    </span>

                    <h3>{item.title}</h3>
                    <p>{item.description}</p>
                  </div>
                  <div className="ex-card-img">
                    <img src={item.exImg} alt="" className="img-fluid" />
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </Container>
      </section>
    </div>
  );
}
